var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutBoardgame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 655.7 641.95",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea444c;}.cls-2{fill:#fff;}.cls-3{fill:#a3a3aa;}.cls-4{fill:#7c7c82;}.cls-5{fill:#fefeff;}.cls-6{fill:#ff5859;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.5,-216.54)",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "769.47 858.49 537.34 824.1 566.08 654.37 788.2 683.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m572.62 677.77 2.38 40.32c-2-3.24 176.49-10.17 161.7 16-14.35 25.36-141.48-26.45-171.33 8.05-30.7 35.49 17.09 106 194.69 90.62l-4.5-41.37s-116.12 14.78-149.82-19.28 159.57 47.65 169.5-36.67c8.83-75.05-202.62-57.67-202.62-57.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m670.68 677.87-2.8 37.42 2.31 0.09 2.81-37.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m611.4 676.11 3.59 39 2.31-0.05-3.59-38.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m646.81 733.22-2.48 34.9 2.28 0.38 2.49-35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m701.23 740.66c0.23 7.78 1 21.35 1.85 34.31l2.31 0.06c-0.76-12-1.59-26.3-1.88-34.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m669.91 793.31c-0.77-0.07-1.54-0.13-2.3-0.21l-3.77 38.9 2.29 0.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m563.47 744.51 38.35 21.66a2 2 0 0 1 1.06-1.95l-38-21.48q-0.75 0.87-1.41 1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m735.8 690-21.8 29.44 2.5 0.47 21.5-29.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m597.3 813.77 21.83-32.39c-0.69-0.34-1.38-0.69-2-1l-21.83 32.39z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.6 710.91 279.18 687.79 251.2 607.47 132.5 657.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m327.3 560.89s-32.62-55.6-116.53-36.66-72.82 120.38-65 130.31 16.75-10.54 16.75-10.54 1.54 13.76 8.76 12.2 8.16-18.92 8.16-18.92 6.49 19.63 14.62 13.79 6.82-22.3 6.82-22.3l15.79-6.27s-29-45.9-12.92-58.87c44.5-36 81.41-15.35 124.85 11.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m376.82 569.6s15.44 45.51 77.39 44.37 68.06-76.81 63.86-85.25-13.27 5.17-13.27 5.17 0.8-10.27-4.52-10.22-8.38 12.57-8.38 12.57-1.9-15.31-8.44-12.24-7.89 15.23-7.89 15.23l-2.91 0.53a8.14 8.14 0 0 0-6.34 10.24c3.33 11.61 7.41 31.4-1.73 36.3-36.41 19.5-59.7-1.12-86.69-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m327.3 560.89s-7.32-12.46-23.92-23.57l-9.18 18.36c11.18 5.42 22.54 12.34 34.4 19.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m377.9 558.8-1.08 10.8s10.17 30 47.1 40.65l-0.71-18.43c-15.95-5.02-30.04-18.09-45.31-33.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310 693.55s1.21 66.76 69.19 30.35c0 0 20.57 9.24 44.85-2.9s13.42-45.66 13.42-45.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m285.31 291.52 32.6 208.63s176.89 9 118.65-233.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.31 291.52s39.12-46.29 99.1-61.94-9.13 20.87-9.13 20.87l101.72-33.91s-19.55 28.69-56.06 35.21l66.5-5.22s-87.39 58.68-202.13 44.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.31 291.52 14.34 86.71s40.42-46.94-14.34-86.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.9 351s6.89-11.81 23.63-16.73l-4.93-8.86s-16.73 9.84-23.62 18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.07 321.69-2.67 8s8.67 0.66 17.33 8l4.67-4.69s-11.33-8.65-19.33-11.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m337.49 367 27.29-4s-3.91-13.12-16.89-12.63-10.4 16.63-10.4 16.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.25 365.49s1.25-3.94 4.18-3.72a5.67 5.67 0 0 1 4.3 3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m404.47 358.32 25.53 1.79s-3-14.25-11.87-15.44-13.66 13.65-13.66 13.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414 359.06 7.3 0.6s-0.91-3.64-3.95-4-3.35 3.4-3.35 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m380 324.71 4.87 58.39s-20-1.06-19.18 5.43 16.78 4.76 16.78 4.76 1 17 14 15.79 9.58-18.89 9.58-18.89 14.3-4.92 11.87-11-19.11 1.14-19.11 1.14l-10.11-57.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.65 378.23-31.6-3.29s8 35.06 31.6 3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.52 387.26a7.86 7.86 0 0 1-1.81-0.21c-4.23-1-6.45-5.05-6.54-5.23l-0.46-0.87h18.73v1.19h-16.65a9.36 9.36 0 0 0 5.2 3.76 8.12 8.12 0 0 0 5.8-1l-5.58-0.23 0.05-1.19 9.17 0.38-1.38 1a11.18 11.18 0 0 1-6.53 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m336.24 379.25-0.45-1.1c1.56-0.62 29-6.52 32.16-7.19l0.25 1.16c-12.2 2.63-30.86 6.69-31.96 7.13z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    transform: "rotate(-79.29 416.62 365.05)",
    x: 416.04,
    y: 353.32,
    width: 1.19,
    height: 23.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m316.48 280.66c3.55-3 7.26-5.81 11-8.52s7.57-5.31 11.42-7.88l5.84-3.75c2-1.21 3.92-2.46 5.92-3.63 4-2.37 8-4.67 12.17-6.74-3.55 3-7.25 5.81-11 8.52-1.87 1.38-3.78 2.67-5.67 4l-5.76 3.87c-3.88 2.52-7.77 5-11.76 7.38s-7.98 4.68-12.16 6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m339.37 274.79q6.47-3.53 13.11-6.64c4.41-2.1 8.88-4.07 13.37-6l6.77-2.8c2.28-0.89 4.54-1.82 6.83-2.66 4.58-1.74 9.19-3.38 13.91-4.78-4.27 2.44-8.65 4.63-13.07 6.73-2.2 1.08-4.44 2.06-6.66 3.09l-6.71 2.93c-4.51 1.89-9 3.75-13.62 5.45s-9.18 3.37-13.93 4.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m338.19 280.07c3.73-0.84 7.42-1.75 11.14-2.61s7.42-1.7 11.15-2.49c7.44-1.63 14.91-3.12 22.38-4.58l11.23-2.09c3.75-0.65 7.5-1.34 11.26-1.94 7.51-1.25 15-2.41 22.63-3.31-7.37 2-14.79 3.75-22.23 5.4-3.71 0.84-7.45 1.59-11.17 2.39l-11.21 2.22c-7.48 1.41-15 2.79-22.5 4-3.76 0.62-7.53 1.18-11.3 1.72s-7.57 1.05-11.38 1.29z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "338 525 324.39 508.19 312.89 509.83 295.24 706.35 463.75 684.6 349.55 504.6 342.21 505.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.24 706.35 326.32 702.34 325.2 509.19 324.39 508.19 312.89 509.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.22 759.58s30.73-10.12 93.19-22.26a20.92 20.92 0 0 0 16.9-21.32l-0.31-8s-125.9 19.45-134.25 49.33c-7.75 27.67 38.45 43.12 114.25 18.8l-8-22.68c-26.49 9.18-73.74 22.81-81.78 6.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.64 708.75c-17.91-24.75-153.64-4.75-153.64-4.75l3.54 11.8a21.07 21.07 0 0 0 23.84 14.7c60.81-10.77 105.62-10.78 105.62-10.78-1.1 17.57-43.15 22.41-70 23.72l4 23.67c70.3-6.18 102.73-36.11 86.64-58.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m340.27 420.84s-13.27 52.07 27.57 39.82l11.23-29.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.3 441.07c0.74 13.07 6.61 26.47 29.54 19.59l5.47-14.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m424.11 743.91s17.33 42.23-4.33 59.56l-1.08-40.07-11.91 1.09-4.34-19.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m364.45 752s-7.27 45.06 17.76 57l-8.06-39.26 11.85-1.66-0.21-20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m269.69 683.49-1.21-0.29c-0.19-0.05-19.13-4.78-27.07-21.36-5.77-12.07-4.42-27.23 4-45.06l0.71-1.51zm-23.69-64.59c-7.61 16.77-8.73 31-3.31 42.34 6.48 13.57 20.66 18.93 24.92 20.28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "546.71 816.2 565.75 824.06 585.74 813.24 584.71 788.43 565.25 781.79 544.84 793.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "565.79 824.04 585.74 813.24 584.71 788.49 564.27 798.28"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.46,
    cy: 808.06,
    rx: 1.96,
    ry: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 571,
    cy: 800.34,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576.25,
    cy: 805.58,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 581.5,
    cy: 810.21,
    r: 1.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.8,
    cy: 791.25,
    rx: 1.62,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.01,
    cy: 788.49,
    rx: 2.1,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.31 617.99 341 625.17 333.69 646.7 351.31 664.18 370.1 655.83 376.88 633.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "340.99 625.21 333.69 646.7 351.27 664.14 359.61 643.07"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 350.67 627.38)",
    cx: 350.65,
    cy: 627.36,
    rx: 1.56,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 356.13 632.14)",
    cx: 356.12,
    cy: 632.12,
    rx: 1.39,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 364.22 628.01)",
    cx: 364.21,
    cy: 628.01,
    rx: 1.39,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 359.69 624.31)",
    cx: 359.68,
    cy: 624.29,
    rx: 1.23,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 368.46 632.09)",
    cx: 368.45,
    cy: 632.08,
    rx: 1.23,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 360.62 636.4)",
    cx: 360.6,
    cy: 636.39,
    rx: 1.56,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.27,
    cy: 646.14,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.86,
    cy: 646.03,
    r: 1.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 369.14 643.84)",
    cx: 369.13,
    cy: 643.83,
    rx: 1.62,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 365.29 649.23)",
    cx: 365.27,
    cy: 649.22,
    rx: 1.62,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.82 360.6 655.53)",
    cx: 360.58,
    cy: 655.51,
    rx: 2.1,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "726.85 812.22 704 813.13 704 807.65 691.21 815.87 704 823.18 704 817.7 726.85 816.78 730.5 821.35 744.21 820.44 737.81 814.04 742.38 805.82 730.5 806.73"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBoardgame);
export default __webpack_public_path__ + "static/media/about_boardgame.8e1ad0bffde9f5bbcf41fee2847aff51.svg";
export { ForwardRef as ReactComponent };